import classNames from "classnames";
import { addHours, format } from "date-fns";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React, { useEffect, useState } from "react";
import { FaTrashAlt } from "react-icons/fa";
import { Api } from "../../../../services/api";
import { formatCurrency } from "../../../../utils/formatCurrency";

export const BaixaHistoricoDialog = ({ rowInfo, close, toast }) => {
    const [historicoBaixaData, setHistoricoBaixaData] = useState()
    const [baixaID, setBaixaID] = useState('')
    const [confirmaCancelamento, setConfirmaCancelamento] = useState(false)
    const [motivo, setMotivo] = useState('')
    const [reload, setReload] = useState()
    const [loading, setLoading] = useState()

    useEffect(() => {
        const consultaBaixas = async () => {
            setLoading(true)
            try {
                const { data } = await Api.get(`/cobranca/consultaBaixas/${rowInfo.cobranca_id}`)
                //console.log(data);
                data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                setHistoricoBaixaData(data)
            } catch (error) {
                console.log(error.response)
                if (!error.response)
                    return toast('error', 'Erro de conexão com o servidor.');
                if (error.response.status === 403)
                    return toast('warning', 'Nenhuma baixa encontrada para esta cobrança');
            } finally {
                setLoading(false)
            }
        }
        consultaBaixas()
    }, [reload])

    const removeBaixa = async (event) => {
        event.preventDefault()
        if (rowInfo.protesto_status === 'ENVIADO')
            return toast('error', 'Não é possível cancelar a baixa de uma cobrança PROTESTADA')
        try {
            const baixaSelecionada = historicoBaixaData.find(b => b.baixa_id === baixaID)
            if (!baixaSelecionada) {
                return toast('error', 'Baixa não encontrada')
            }

            await Api.put('/cobranca/removeBaixa', {
                baixa_id: baixaID,
                associado_id: baixaSelecionada.associado_id,
                motivo: motivo
            })

            toast('success', 'Baixa removida com sucesso')
            setConfirmaCancelamento(false)
            setMotivo('')
            setReload(prevReload => !prevReload)
        } catch (error) {
            console.log(error.response)
            if (!error.response)
                return toast('error', 'Erro de conexão com o servidor.');
            if (error.response.status === 403)
                return toast('warning', 'Erro ao realizar baixa');
            return toast('error', 'Erro ao remover baixa');
        }
    }

    const removeButton = (baixa_id, status) => {
        if (status)
            return (
                <Button
                    severity="danger"
                    rounded
                    icon={<FaTrashAlt />}
                    onClick={() => { setConfirmaCancelamento(true); setBaixaID(baixa_id) }}
                />
            )
        else
            return (
                <div>-</div>
            )
    }


    const tipoBodyTemplate = (e) => {
        let type = "-";
        if (e.baixa_categoria === "Baixa Total") {
            type = "qualified";
            //   value = "EM ABERTO";
        }
        if (e.baixa_categoria === "Baixa Parcial") {
            type = "new";
            // value = "EM ABERTO";
        }
        return (
            <div className={`customer-badge status-${type}`} style={{ display: 'flex', justifyContent: "center" }}>
                <p>{e.baixa_categoria}</p>
            </div>
        );
    };

    const statusBodyTemplate = (e) => {
        let type = "-";
        if (e.baixa_status) {
            type = "bg-emerald-300 text-emerald-800";
            //   value = "EM ABERTO";
        }
        else {
            type = "bg-red-300 text-red-700";;
            // value = "EM ABERTO";
        }
        return (
            <div className="flex justify-center items-center ">
                <span className={classNames(
                    'text-nowrap py-1 px-2 justify-center flex w-auto',
                    type
                )}
                >
                    <p className="uppercase text-sm font-bold">
                        {e.baixa_status ? "BAIXADO" : "CANCELADA"}
                    </p>
                </span>
            </div>
        );
    };

    return (
        <Dialog
            visible
            header={`Histórico de baixas`}
            pt={{
                root: 'w-screen md:w-[70vw] max-h-[90vh] ',
                header: classNames('flex items-center justify-between shrink-0',
                    'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
                    'dark:bg-gray-900  dark:text-white/80'),
                content: ({ state }) => ({
                    className: classNames('overflow-y-scroll w-full max-h-[80vh]',
                        'bg-white text-gray-700 px-6 pb-8 pt-0',
                        'rounded-bl-lg rounded-br-lg',
                        'dark:bg-gray-900 dark:text-white/80 ', {
                        "grow": state.maximized
                    })
                }),
            }}
            onHide={() => close()}
        //footer={footer}
        >
            <Dialog
                visible={confirmaCancelamento}
                header={`Confirmar Cancelamento`}
                style={{
                    minHeigth: '30vw',
                    minWidth: '30vw',
                    textAlign: 'center',

                }}
                onHide={() => setConfirmaCancelamento(false)}
            //footer={footer}
            >
                <div className='grid justify-center w-full'>
                    <form onSubmit={(e) => removeBaixa(e)} className="grid w-5/6 ">
                        <h4>Descreva o motivo da reversão da baixa:</h4>
                        <InputText
                            className="w-full"
                            onChange={(e) => setMotivo(e.target.value)}
                            required
                            value={motivo}
                        >
                        </InputText>
                        <Button
                            severity="danger"
                            className="w-full mt-6"
                            //onClick={()=>removeBaixa(baixaID)}
                            type="submit"
                            label="Confirmar"
                        />
                    </form>
                </div>
            </Dialog>
            <div className="grid justify-center w-full overflow-auto">
                <DataTable
                    value={historicoBaixaData}
                    header=""
                    loading={loading}
                    emptyMessage="Nenhuma baixa adicionada"
                >
                    <Column field="baixa_descricao" header="Descrição" />
                    <Column field="valor_para_pagamento" header="Valor Cobrança" body={(rowData) => formatCurrency(rowData.valor_para_pagamento)} />
                    <Column field="valor_total" header="Valor Baixa" body={(rowData) => formatCurrency(rowData.valor_total)} />
                    <Column field="data_pagamento" header="Data Baixa" body={(rowData) => format(addHours(new Date(rowData.data_pagamento), 3), 'dd/MM/yyyy')} />
                    <Column field="data_pagamento" header="Data Cancelamento" body={(rowData) => { return rowData.updated_at ? format(addHours(new Date(rowData.updated_at), 3), 'dd/MM/yyyy hh:mm:ss') : '-' }} />
                    <Column field="baixa_categoria" header="Tipo" style={{ width: '180px' }} body={(rowData) => tipoBodyTemplate(rowData)} />
                    <Column field="baixa_status" header="Status" style={{ width: '180px' }} body={(rowData) => statusBodyTemplate(rowData)} />
                    <Column field="baixa_id" header="Remover" body={(rowData) => removeButton(rowData.baixa_id, rowData.baixa_status)} />
                </DataTable>
            </div>

        </Dialog>
    )
}